import { useState } from 'react';
import { Field } from '@/components/ui';

const NEW = '__novo__';

interface Props {
  label: string;
  value: string;
  options: readonly string[];
  onChange: (value: string) => void;
  /** Texto da opção que abre o campo livre — "+ Novo grupo…". */
  newLabel: string;
  placeholder: string;
  newPlaceholder: string;
  error?: string;
  hint?: string;
  disabled?: boolean;
  maxLength?: number;
}

/**
 * Lista suspensa das opções que já existem, com uma última opção para digitar
 * uma nova. Um valor que não está na lista (um nome novo) abre já no campo livre.
 */
export function PickOrCreate({ label, value, options, onChange, newLabel, placeholder, newPlaceholder, error, hint, disabled, maxLength = 80 }: Props) {
  const [creating, setCreating] = useState(() => value !== '' && !options.includes(value));
  const typing = creating || (value !== '' && !options.includes(value));

  return (
    <Field label={label} error={error} hint={hint}>
      <select
        className="inp"
        value={typing ? NEW : value}
        disabled={disabled}
        onChange={(event) => {
          const next = event.target.value;
          setCreating(next === NEW);
          onChange(next === NEW ? '' : next);
        }}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
        <option value={NEW}>{newLabel}</option>
      </select>
      {typing ? (
        <input
          className="inp"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={newPlaceholder}
          aria-label={newPlaceholder}
          maxLength={maxLength}
          autoFocus={creating}
          disabled={disabled}
          style={{ marginTop: 6 }}
        />
      ) : null}
    </Field>
  );
}
